import { ReportingErrorBoundary } from "@/modules/error/ReportingErrorBoundary.tsx";
import { Suspense, type ReactNode } from "react";

export interface FallbackRenderProps {
    isDataError: boolean;
    items: any[];
    isLoading: boolean;
}

export function WSelectWrapper({
    fallback,
    children,
}: {
    fallback: (props: FallbackRenderProps) => ReactNode;
    children: ReactNode;
}) {
    return (
        <ReportingErrorBoundary
            FallbackComponent={() => fallback({ items: [], isDataError: true, isLoading: false })}
            tags="WSelectWrapper"
        >
            <Suspense fallback={fallback({ items: [], isLoading: true, isDataError: false })}>{children}</Suspense>
        </ReportingErrorBoundary>
    );
}
